<template>
  <header  :style="{ top: `${top}px`}">
    <order-step></order-step>
    <div style="background:#EBEBEB">
      <div class="progress-bar" :class="[current === total ? 'bar-ok' : '']" :style="{ width: `${progressBarWidth}%` }">
        <div class="wrap-progressNum">
          <span class="progressNum">{{current+'/'+total}}</span>
        </div>
      </div>
    </div>
    <p class="tips" :class="topTipColor" v-if="isInvite">
      <marquee @setColor="setColor"></marquee>
    </p>
    <!--当前估价机型-->
    <p class="phone-model">
      <span>Current pricing model:</span>
      <span class="title">{{ title }}</span>
    </p>
  </header>
</template>

<script>
import marquee from "./marquee.vue";
// import { isHasTitleInAppObliged } from '@/config/index.js';
// import orderStep from '@/'
import orderStep from '@/components/PCOrderStep';
export default {
  props: ["current", "total", "title"],
  components: {
    marquee,
    orderStep
  },
  data() {
    return {
      topTipColor:'',
      isInvite: true
    };
  },
  methods: {
    setColor(o){
      this.topTipColor = o?.color || '';
      this.isInvite = o?.isInvite ? false : true
    },
  },
  computed: {
    /**
     * 进度条长度
     */
    progressBarWidth() {
      return (this.current / this.total) * 100;
    },
    top () {
      return !this.$isOpenInWebview || isHasTitleInAppObliged ? 44 : 0
    },
  },
};
</script>

<style lang="less" scoped>
// @import "../../../styles/reset.scss";
header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 1;
  .progress-bar {
    height: 24px;
    background: #405FFF;
    border-radius: 0 100px 100px 0;
    font-size: 9px;
    color: #fff;
    text-align: right;
    box-sizing: border-box;
    position: relative;
    .wrap-progressNum{
      position: absolute;
      top: 0px;
      right: 8px;
      font-size: 20px;
      transform-origin: 100% 0%;
      //line-height: 1;
      // transform: scale(0.5);
    }
  }
  .tips {
    height: 40px;
    padding: 0 24px;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFF3E8;
    // border: 1px solid #f2f3f5;
    .total {
      color: #808080;
    }
  }
  .tipInvite {
    height: 22px;
    padding: 0 21px;
  }
  .tips.yellow{
    background: #fbeae4;
  }
  .tips.red{
    background: #f7e4e6;
  }
  .tips .total-box{
    width: 55px;
    text-align: right;
  }
  .phone-model {
    height: 76px;
    line-height: 76px;
    padding-left: 24px;
    font-size: 28px;
    color: #999;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    .title {
      flex: 1;
      color: #333;
      font-weight: 400;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-left: 16px;
    }
    @media screen and (max-width: 320px) {
      .title {
        // @include singleEllipsis(210px);
      }
    }
  }

  h1 {
    font-size: 16px;
    margin-right: 12px;
  }
  .tag {
    width: 70px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    color: #ff592c;
    background: #fff5f4;
    border-radius: 5px;
  }

  .bar-ok {
    border-radius: 0;
  }
}
</style>
